export function group_by_size(list, size) {
    if (!list || size === 0) {
        return null
    }
    if(list.length === 0){
        return []
    }
    
    if (size >= list.length) {
        return [list];
    }
    const res = [];

    let child_list = [];
    list.forEach((item, idx) => {
        if (child_list.length < size) {
            child_list.push(item)
        } else {
            res.push(child_list);
            child_list = []
            child_list.push(item)
        }
    })
    if (child_list.length !== 0) {
        res.push(child_list);
    }

    return res;

}

